import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import styles from '../css/MyUser.module.css';
import axiosInstance from '../config/axiosConfig';

export default function MyUser() {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user?.id) {
      setLoading(false);
      return;
    }

    const fetchUsuario = async () => {
      try {
        const response = await axiosInstance.get(`/usuarios/${user.id}`);
        setUsuario(response.data);
        setError(null);
      } catch (err) {
        console.error("Error al obtener usuario:", err);
        setError('No se pudo cargar la información del usuario');
      } finally {
        setLoading(false);
      }
    };

    fetchUsuario();
  }, [user?.id]);

  if (loading) return <div>Cargando...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!usuario) return <div>Sin datos del usuario</div>;

  return (
    <div className={styles.contentWrapper}>
      <h1>Usuario {usuario.username} [{usuario.email}]</h1>
      <table>
        <tbody>
          <tr>
            <td><b>Usuario</b></td>
            <td><b>Rol</b></td>
          </tr>
          <tr>
            <td>{usuario.username}</td>
            <td>{usuario.rol}</td>
          </tr>

          <tr>
            <td><b>Nombre Completo</b></td>
            <td><b>Fecha de Registro</b></td>
          </tr>
          <tr>
            <td>{usuario.nombre}</td>
            <td>{usuario.registro}</td>
          </tr>

          <tr>
            <td><b>Correo</b></td>
            <td><b>Telefono</b></td>
          </tr>
          <tr>
            <td>{usuario.email}</td>
            <td>{usuario.telefono}</td>
          </tr>

          <tr>
            <td><b>Puesto de Trabajo</b></td>
            <td><b>Institucion</b></td>
          </tr>
          <tr>
            <td>{usuario.puesto}</td> 
            <td>{usuario.institucion}</td>
          </tr>

          <tr>
            <td><b>Estado</b></td>
            <td></td>
          </tr>
          <tr>
            <td>{usuario.estado}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}